export default "/assets/moderate-active-purple.svg";